<template>
  <div>
    <q-dialog v-model="showConsentLetterModal" :maximized="true" @input="(val) => $emit('input', val)">
      <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
        <q-header class="bg-primary ">
          <q-toolbar class="header">
            <q-toolbar-title><translate>CONSENT_LETTER</translate></q-toolbar-title>
            <q-btn v-close-popup flat round icon="close" />
          </q-toolbar>
        </q-header>
        <q-page-container class="scroll">
          <consent-letter style="margin-top: 50px;" ref="crudLayout" name="_CONSENT_LETTER"
            interface="consentLetter.gravar" id="_consent-letter" @closeConsentLetterModal="closeModal" />
        </q-page-container>
      </q-layout>
    </q-dialog>
  </div>
</template>
<script>

import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import ConsentLetter from '../consent-letter/consent-letter/ConsentLetter.vue'
import ConsentLetterModel from '../consent-letter/consent-letter/ConsentLetterModel'
const { CrudLayout } = JtCrud

@Component({
  name: 'TechnicalAssessment',
  components: { CrudLayout, ConsentLetter },
  props: {
    id: String,
    interface: String,
    name: String,
    params: Object,
    showConsentLetterModal: {
      type: Boolean,
      required: false,
      default: false
    }
  }
})
class TechnicalAssessment extends Vue {
  state = ConsentLetterModel.getInstance();
  beforeDestroy () {
    this.state.setLandfill({})
    this.state.setClient({})
    this.state.setConsentLetterItens({})
    this.state.setTechinicalAssessmentId({})
  }

  closeModal () {
    this.showConsentLetterModal = false
    this.$emit('input', this.showConsentLetterModal)
  }
}
export default TechnicalAssessment
</script>
<style lang="stylus" scoped>

</style>
